<template>
    <div>


        <!-- Modal -->
        <div class="modal fade" id="addCarrinhoPizza" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" >Pizza ( {{formAddCarrinho.tamanho.nome}} ) </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="adicionar()">
                    <div class="modal-body">



                        <!-- Sabores -->
                        <div
                            v-if="!isEmpty"
                            class="card my-3 p-3 d-flex flex-colunm"
                        >

                            <div class="row">
                                <div class="col text-center">
                                    <h5>Sabor:</h5>
                                    <p>Nesta pizza você pode escolher {{formAddCarrinho.tamanho.qms==1?'apenas':'até'}} {{formAddCarrinho.tamanho.qms}} {{formAddCarrinho.tamanho.qms==1?'sabor':'sabores'}} </p>
                                </div>
                            </div>
                            <div class="row" >
                                <table class="table">
                                    <tbody>
                                        <tr
                                            v-for="(sabor, index) in formAddCarrinho.sabores"
                                            :key="index"
                                        >
                                            <td scope="row">
                                                <div v-if="sabor.imagem" class="p-1 align-self-center">
                                                    <img class="img-thumb" :src="sabor.imagem" style="max-height: 72px ; max-width: 72px" >
                                                </div>
                                            </td>
                                            <td>
                                                <div class="p-1">
                                                    <h6>{{sabor.nome}}</h6>
                                                    <span style="font-weight:normal; font-size:12px">{{sabor.descricao}}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <a class="btn btn-danger" href="#"  @click="formAddCarrinho.sabores.splice(index, 1)" >Excluir</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="formAddCarrinho.sabores.length<formAddCarrinho.tamanho.qms" class="form-group row">
                                <div class="col text-center">
                                    <a class="btn b-btn" @click="modalEscolherSabor()"  href="#"> Escolher {{formAddCarrinho.sabores.length>0?'outro':''}} Sabor </a>
                                </div>
                            </div>


                        </div>


                        <!-- Bordas -->

                        <div v-if="!isEmpty&&formAddCarrinho.tamanho.bordas.length>0" class="card my-3 p-3 d-flex flex-colunm">
                            <div class="mb-3 text-center">
                                <h5>Tipo de borda:</h5>
                            </div>
                            <div
                                v-for="borda in formAddCarrinho.tamanho.bordas" :key="borda.id"
                                class="d-flex flex-row my-1"
                            >
                                <template v-if="borda.disponivel==1">

                                    <div class="d-inline custom-control custom-switch ml-3">

                                        <input type="radio"
                                            :id="'borda-'+borda.id"
                                            :value="borda"
                                            name="borda"
                                            v-model="formAddCarrinho.borda"
                                            class="custom-control-input"
                                        >
                                        <label :for="'borda-'+borda.id" class="custom-control-label">{{borda.nome}}</label>
                                    </div>

                                    <div class="ml-auto">
                                        <div style="width:110px; text-align: center ">
                                            <span >+ {{borda.valor}}</span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>


                        <!-- Massa -->

                        <div v-if="!isEmpty && formAddCarrinho.tamanho.massas.length>0" class="card my-3 p-3 d-flex flex-colunm">
                            <div class="mb-3 text-center">
                                <h5>Tipo de Massa:</h5>
                            </div>
                            <div
                                v-for="massa in formAddCarrinho.tamanho.massas" :key="massa.id"
                                class="d-flex flex-row my-1"
                            >
                                <template v-if="massa.disponivel==1">

                                    <div class="d-inline custom-control custom-switch ml-3">

                                        <input type="radio"
                                            :id="'massa-'+massa.id"
                                            :value="massa"
                                            name="massa"
                                            v-model="formAddCarrinho.massa"
                                            class="custom-control-input"
                                        >
                                        <label :for="'massa-'+massa.id" class="custom-control-label">{{massa.nome}}</label>
                                    </div>


                                    <div class="ml-auto">
                                        <div style="width:110px; text-align: center ">
                                            <span >+ {{massa.valor}}</span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <!-- Adicionais -->

                        <div v-if="!isEmpty && formAddCarrinho.tamanho.adicionais.length>0" class="card my-3 p-3 d-flex flex-colunm">
                            <div class="mb-3 text-center">
                                <h5>Adicionais:</h5>
                            </div>
                            <div
                                v-for="adicional in formAddCarrinho.tamanho.adicionais" :key="adicional.id"
                                class="d-flex flex-row my-1"
                            >
                                <template >

                                    <div class="d-inline custom-control ">
                                        <p>{{ adicional.nome }}</p>
                                    </div>


                                    <div class="ml-auto">
                                        <div style="width:110px; text-align: center ">
                                            <span >+ {{adicional.valor}}</span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>





                        <!-- OBS -->

                        <div class="card my-3 p-3 d-flex flex-colunm">
                            <div class="text-center mb-3">
                                <h5>Alguma Observação?</h5>
                            </div>
                            <div>
                                <textarea placeholder="Ex: Sem azeitona" v-model="formAddCarrinho.obs"></textarea>
                            </div>
                        </div>


                        <div class="d-flex flex-row">
                            <div>
                                <div class="mb-2">
                                    Quantidade:
                                </div>
                                <div>
                                    <button type="button" class="btn b-btn" v-on:click="formAddCarrinho.quantidade>1?formAddCarrinho.quantidade -= 1:''"> - </button>
                                    <div class="qt"> {{formAddCarrinho.quantidade}}  </div>
                                    <button type="button" class="btn b-btn" v-on:click="formAddCarrinho.quantidade += 1" > + </button>
                                </div>
                            </div>

                            <div class="ml-auto">
                                <div class="mb-2">
                                    Valor Total:
                                </div>
                                <div>
                                    <h3>R$ {{formatarMoeda(vtotal.toFixed(2))}}</h3>
                                </div>

                            </div>

                        </div>






                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="submit" class="btn b-btn">Adicionar</button>
                    </div>
                  </form>
                </div>
            </div>


        </div>

        <!-- Modal escolher Sabor -->
        <div class="modal fade" id="escolherSabor" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" >Escolher Sabor</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form >
                    <div class="modal-body">

                        <div class="row">


                            <div
                                v-for="sabor in formAddCarrinho.tamanho.sabores.filter(sabor => sabor.disponivel==1)"
                                :key="sabor.id"
                                class="col-12 px-1 my-1 escolherSabor"
                            >
                                <a @click="selecionarSabor(sabor)">
                                    <div class="card p-2">
                                        <div class="d-flex flex-row" style="height:100%">
                                            <div v-if="sabor.imagem" class="p-1 align-self-center">
                                                <img class="img-thumb" :src="sabor.imagem" style="max-height: 72px ; max-width: 72px" >
                                            </div>
                                            <div class="p-1">
                                                <h6>{{sabor.nome}}</h6>
                                                <span style="font-weight:normal; font-size:12px">{{sabor.descricao}}</span>
                                            </div>
                                            <div class="p-1 ml-auto" >
                                                <div class="d-flex flex-column justify-content-end" style="width:80px; height:100%">
                                                    <span v-if="sabor.promocao" class="badge badge-pill badge-danger align-self-center mb-auto">Em Promoção</span>
                                                    <del v-if="sabor.promocao" class="align-self-center mb-2">R$ {{formatarMoeda(sabor.valor)}}</del>
                                                    <span v-if="sabor.promocao" class="align-self-center">R$ {{formatarMoeda(sabor.promocao.valor)}}</span>
                                                    <span v-else class="align-self-center">R$ {{formatarMoeda(sabor.valor)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>



                        </div>

                    </div>

                </form>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import api from "../service/api";

export default {
    data () {
        return {
            montarPizza:[],
            formAddCarrinho: new Form({
                tipo: 2,
                tamanho:{},
                borda: {},
                massa: {},
                sabores: [],
                quantidade: 1,
                obs:''
            }),
        }
    },

    watch: {

        pizzaAtiva: function (pizza) {
            this.resetarPizza(pizza)
        },

    },

    methods: {

        async carregarPizzas(){
            this.carregando_prod = true
            await api
            .get('/pizzas/tamanhos-all')
            .then((response) => {
                this.montarPizza = response.data.data;

            })
            this.carregando_prod = false;
        },

        adicionar() {
            if (this.formAddCarrinho.sabores.length>0) {

                /* if (!this.estavazio(this.formAddCarrinho.massa)) {

                    if (!this.estavazio(this.formAddCarrinho.borda)) {
                        let obj1 = JSON.parse(JSON.stringify(this.formAddCarrinho));

                        this.$store.dispatch('adicionarProduto', obj1).then();
                        $('#addCarrinhoPizza').modal('hide');
                        this.resetarPizza(this.pizzaAtiva);

                        Toast.fire({
                            icon: 'success',
                            title: "Item Adicionado no Carrinho"
                        });

                    }else{

                        Swal.fire({
                            icon: 'error',
                            title: 'Você precisa escolher um tipo de borda',
                            showConfirmButton: false,
                            timer: 2500
                        });

                    }

                }else{

                    Swal.fire({
                        icon: 'error',
                        title: 'Você precisa escolher um tipo de massa',
                        showConfirmButton: false,
                        timer: 2500
                    });
                } */

                let obj1 = JSON.parse(JSON.stringify(this.formAddCarrinho));

                this.$store.dispatch('adicionarProduto', obj1).then();
                $('#addCarrinhoPizza').modal('hide');

                Toast.fire({
                    icon: 'success',
                    title: "Item Adicionado no Carrinho"
                });

                let sabores = [];

                for (let index = 0; index < this.formAddCarrinho.sabores.length; index++) {
                    const element = this.formAddCarrinho.sabores[index];
                    sabores.push(element.nome);
                }

                fbq('track', 'AddToCart', {
                    content_name: "Pizza "+this.formAddCarrinho.tamanho.nome+"("+sabores.toString()+")",
                    content_type: 'pizza',
                    quantity: this.formAddCarrinho.quantidade,
                    value: this.vtotal,
                    currency: 'BRL'
                });

                this.resetarPizza(this.pizzaAtiva);
            }else{

                Swal.fire({
                    icon: 'error',
                    title: 'Você precisa escolher pelo menos um sabor',
                    showConfirmButton: false,
                    timer: 2500
                });

               /*  Toast.fire({
                    icon: 'success',
                    title: "Você precisa escolher pelo menos um sabor"
                }); */
            }

        },

        estavazio(objeto){
            return Object.keys(objeto).length === 0 && objeto.constructor === Object
        },


        formatarMoeda(valor){
              return valor.replace(".",",")
        },

        async modalEscolherSabor(){
            // let obj1 = JSON.parse(JSON.stringify(prod));
            // await this.$store.dispatch('atualizarProdutoAtivo', obj1).then();
            // await this.$store.dispatch('showModalAddCarrinho').then();

            $('#addCarrinhoPizza').modal('hide');

            setTimeout(function() {
                $('#escolherSabor').modal('show').on('hidden.bs.modal', function (e) {
                    $('#addCarrinhoPizza').modal('show');
                })
            }, 400);

        },

        selecionarSabor(sabor){

            this.formAddCarrinho.sabores.push(sabor);

            $('#escolherSabor').modal('hide');

        },


        limparForm() {
            this.formAddCarrinho.reset();
            this.formAddCarrinho.errors.errors = {};
        },

        resetarPizza(pizzaAtiva)  {
            this.limparForm()
            let tamanho = this.montarPizza.find(pizza => pizza.id==pizzaAtiva.tamanho_id);
            this.formAddCarrinho.tamanho = tamanho;
            this.formAddCarrinho.sabores = tamanho.sabores.filter(sabor => sabor.id==pizzaAtiva.sabor_id);
            // this.saborAtivo = tamanhoArray[0].sabores.filter(sabor => sabor.id==pizzaAtiva.sabor_id);
        },





    },

    mounted () {
        this.carregarPizzas();
        // this.resetarPizza(this.pizzaAtiva);
    },


    computed: {

        pizzaAtiva() {
            return this.$store.state.pizzaAtiva.main;
        },

        isEmpty: function() {
            return Object.keys(this.formAddCarrinho.tamanho).length === 0 && this.formAddCarrinho.tamanho.constructor === Object;
        },


        vtotal: function() {


            let valorTotalSabores = parseFloat(0);
            let valorTotalAdicionais = parseFloat(0);
            let valorBorda = parseFloat(this.formAddCarrinho.borda.valor??0);
            let valorMassa = parseFloat(this.formAddCarrinho.massa.valor??0);
            let valorSabor = 0;

            for (let index = 0; index < this.formAddCarrinho.sabores.length; index++) {

                if (this.formAddCarrinho.sabores[index].promocao) {
                    valorTotalSabores += parseFloat(this.formAddCarrinho.sabores[index].promocao.valor);
                }else{
                    valorTotalSabores += parseFloat(this.formAddCarrinho.sabores[index].valor)
                }

            }

            for (let index = 0; index < this.formAddCarrinho.tamanho.adicionais.length; index++) {

                valorTotalAdicionais += parseFloat(this.formAddCarrinho.tamanho.adicionais[index].valor);

            }

            if (this.formAddCarrinho.sabores.length>0) {
                valorSabor = valorTotalSabores/this.formAddCarrinho.sabores.length;
            }

            return this.formAddCarrinho.quantidade*(valorSabor+valorBorda+valorMassa+valorTotalAdicionais)
        }



    }

}
</script>

<style scoped>

.card {
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(0,0,0,0),rgba(0,0,0,0), rgba(0,0,0,0.07));
    border: 1px solid rgba(0, 0, 0, 0.20);
    border-radius: 0.8rem;
}

.card textarea{
    width: 100%;
    height: 100px;
    padding: 5px;
}

.card h5 {
    background-color: var(--btnbg3);
    filter: opacity(0.7);
    padding: 10px;
    border-radius: 10px;
    color: var(--btntxt3);
    text-transform: uppercase;
}

.escolherSabor a{
    text-decoration: none;
    cursor: pointer;
}

.escolherSabor a .card:hover{
    box-shadow: 2px 2px 6px 0px #a7a7a7;
}

.title{
    text-align: center;
}

.title img {
    margin-left: 20px;
    padding: 4px;
    border: 1px solid #9c9c9c;
    border-radius: 2px;
    object-fit: cover;
    box-shadow: 2px 2px 4px 0px #a7a7a7;
}

.qt{
    display: inline-block;
    border: 1px solid rgba(0, 0, 0, 0.20);
    font-size: 1.2rem;
    width: 35px;
    height: 30px;
    text-align: center;
}

.custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: var(--btnbg3);
    background-color: var(--btnbg3);
}

</style>
